function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "eye close");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-1376.000000, -1184.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eye-close",
  transform: "translate(1376.000000, 1184.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "box",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "icon24/eye-close",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,6 C15.0457916,6 18.0915832,7.66983236 21.1373748,11.0094971 L21.4321187,11.3379122 C21.7662352,11.7160837 21.766235,12.2839372 21.4321183,12.6621086 C18.2880789,16.2207029 15.1440394,18 12,18 C8.95420841,18 5.90841681,16.3301676 2.86262522,12.9905029 L2.56788129,12.6620878 C2.2337648,12.2839163 2.23376496,11.7160628 2.56788166,11.3378914 C5.7119211,7.77929713 8.85596055,6 12,6 Z M12,8 C9.75667717,8 7.39115748,9.21175598 4.90127097,11.7622021 L4.673,12 L4.89659283,12.2328027 C7.29778042,14.6934247 9.58012119,15.9083843 11.7501144,15.9950059 L12,16 C14.2433228,16 16.6088425,14.788244 19.098729,12.2377979 L19.326,11.999 L19.1034072,11.7671973 C16.7022196,9.3065753 14.4198788,8.09161573 12.2498856,8.00499407 L12,8 Z",
  id: "Rectangle-Copy"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(12.000000, 19.500000) rotate(180.000000) translate(-12.000000, -19.500000) ",
  x: 11,
  y: 17,
  width: 2,
  height: 5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(7.441025, 18.081570) rotate(30.000000) translate(-7.441025, -18.081570) ",
  x: 6.4410254,
  y: 15.3315699,
  width: 2,
  height: 5.5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  transform: "translate(16.550000, 18.081570) scale(-1, 1) rotate(30.000000) translate(-16.550000, -18.081570) ",
  x: 15.55,
  y: 15.3315699,
  width: 2,
  height: 5.5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(4.074874, 15.474874) rotate(45.000000) translate(-4.074874, -15.474874) ",
  x: 3.07487373,
  y: 12.9748737,
  width: 2,
  height: 5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  transform: "translate(19.900000, 15.474874) scale(-1, 1) rotate(45.000000) translate(-19.900000, -15.474874) ",
  x: 18.9,
  y: 12.9748737,
  width: 2,
  height: 5,
  rx: 1
})))));

var SvgEyeclose = function SvgEyeclose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeclose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye close.16fe2f6b.svg";
export { ForwardRef as ReactComponent };